import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../../common/components';
import {
  wrapperStyles,
  bodyStyles,
  contentStyles,
  bottomSectionStyles,
} from '../../../../common/styles';
import {
  helperRowStyles,
  availableRowStyles,
  availableAssetInfoStyles,
  availableTrailingStyles,
} from './withdrawalAmountStyles';

const navBarSkeletonStyles = css({
  display: 'flex',
  minHeight: '48px',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 'medium',
});

const chipsSkeletonRowStyles = css({
  display: 'flex',
  gap: 'extra_small_2',
  py: 'extra_small_2',
});

export const WithdrawalAmountSkeleton = () => (
  <div data-testid="withdrawal-amount-skeleton" className={wrapperStyles}>
    <div className={navBarSkeletonStyles}>
      <div className={css({ flex: 1 })} />

      <SkeletonElement width="100px" height="18px" />

      <div
        className={css({
          flex: 1,
          display: 'flex',
          justifyContent: 'flex-end',
        })}
      >
        <SkeletonElement width="24px" height="24px" borderRadius="50%" />
      </div>
    </div>

    <div className={bodyStyles}>
      <div className={contentStyles}>
        <div>
          <SkeletonElement width="24px" height="24px" borderRadius="50%" />

          <SkeletonElement width="40px" height="18px" />
        </div>

        <SkeletonElement width="160px" height="80px" />

        <div className={chipsSkeletonRowStyles}>
          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />

          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />

          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />

          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />
        </div>

        <div className={helperRowStyles}>
          <SkeletonElement width="120px" height="14px" />
        </div>

        <div className={availableRowStyles}>
          <SkeletonElement width="40px" height="40px" borderRadius="50%" />

          <div className={availableAssetInfoStyles}>
            <SkeletonElement width="30px" height="12px" />

            <SkeletonElement width="80px" height="16px" />
          </div>

          <div className={availableTrailingStyles}>
            <SkeletonElement width="50px" height="12px" />

            <SkeletonElement width="60px" height="16px" />
          </div>
        </div>

        <SkeletonElement width="100%" height="60px" />
      </div>
    </div>

    <div className={bottomSectionStyles}>
      <SkeletonElement width="100%" height="56px" borderRadius="4px" />
    </div>
  </div>
);
